module.exports = "/images/affiche-circuit.png?18ae61bc84d4abcf0babff3c28e077af";